import ApiManagementReducer from 'store/api-management/reducers';

export default ApiManagementReducer;
